const formatter = new Intl.NumberFormat('id-ID', {
  style: 'currency',
  currency: 'IDR',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

/**
 * Integer rupiah -> "Rp1.000.000" (no decimals, no space after "Rp").
 * Returns '' for null/undefined/NaN so callers can decide what to show.
 */
export default function formatIDR(amount) {
  if (amount === null || amount === undefined || amount === '') return '';
  const n = Number(amount);
  if (!Number.isFinite(n)) return '';
  // Intl inserts a (non-breaking) space after "Rp"; the house style has none.
  return formatter.format(Math.round(n)).replace(/\s/g, '');
}

export { formatIDR };
